/** Service Desk console: Quarantine ng e-mail (CH-030, SD-S1-64 screen). Mga mail na may pinangalanang ticket pero hindi makasali rito. */
export const serviceQuarantine = {
  nav: { quarantine: "Quarantine ng e-mail" },
  title: "Quarantine ng e-mail",
  subtitle: "Mga mail na may pinangalanang ticket pero hindi makasali rito. Walang anumang ipinapadala pabalik sa nagpadala.",
  noRights: { title: "Hindi mo puwedeng suriin ang mga mail sa quarantine", body: "Kailangan ng pahintulot ng ticket manager para rito. Hilingin sa may-ari ng workspace na ibigay ito sa iyo." },
  filter: { label: "Ipakita ang mga mensahe", pending: "Naghihintay", accepted: "Inilabas", rejected: "Itinapon" },
  table: {
    label: "Mga mensaheng nasa quarantine",
    from: "Mula kay",
    subject: "Paksa",
    reason: "Bakit naghihintay",
    ticket: "Ticket",
    received: "Natanggap",
    expires: "Mawawala",
    noSubject: "(walang paksa)",
    noTicket: "Walang pinangalanan",
    open: "Buksan ang mensahe mula kay {{from}}",
    showing: "Ipinapakita ang {{shown}} sa {{total}} mensahe",
    loadMore: "Magpakita pa",
  },
  reason: {
    sender_mismatch: "Hindi tugma ang nagpadala sa ticket",
    no_visibility: "Hindi nakikita ng nagpadala ang ticket na ito",
    unknown_token: "Hindi kilalang reply address",
    revoked_token: "Binawi ang reply address",
    auth_failed: "Hindi ma-verify ang nagpadala",
  },
  status: { pending: "Naghihintay", accepted: "Inilabas", rejected: "Itinapon" },
  detail: {
    title: "Mensaheng nasa quarantine",
    description: "Basahin ang isinulat ng nagpadala. Ilabas ito para maidagdag sa ticket bilang pampublikong mensahe, o itapon ito.",
    to: "Ipinadala sa",
    received: "Natanggap {{time}}",
    expires: "Made-delete sa {{time}} kung walang magpapasya",
    reviewed: "Napagpasyahan {{time}}",
    ticket: "Pinangalanang ticket",
    openTicket: "Buksan ang {{number}}",
    noTicket: "Walang pinangalanang ticket ang mensahe, kaya itatapon lang ito.",
    body: "Mensahe",
    noBody: "(walang teksto ang mensahe)",
    files: "Mga file ({{count}})",
    filesHint: "Sinusuri para sa virus kapag inilabas ang mensahe.",
    checks: "Mga pagsusuri sa paghahatid",
    spf: "SPF",
    dkim: "DKIM",
    unknownCheck: "Hindi iniulat",
    messageId: "Message ID",
    close: "Isara",
  },
  actions: {
    release: "Ilabas sa ticket",
    discard: "Itapon",
    cancel: "Kanselahin",
    releaseTitle: "Ilabas sa {{ticket}}?",
    releaseBody: "Ang mga salita at nasuring file ng nagpadala ay magiging pampublikong mensahe sa {{ticket}}. Makikita ito ng kliyente at ng team.",
    releaseConfirm: "Ilabas sa ticket",
    released: "Inilabas sa {{ticket}}.",
    discardTitle: "Itapon ang mensaheng ito?",
    discardBody: "Hindi ito idadagdag sa anumang ticket at made-delete ang mga file. Hindi sasabihan ang nagpadala.",
    discardConfirm: "Itapon ang mensahe",
    discarded: "Naitapon ang mensahe.",
    decided: "May nagpasya na sa mensaheng ito. Na-refresh ang listahan.",
    failed: "Hindi namin ito nakumpleto. Walang nabago.",
  },
  empty: {
    title: "Malinis ang quarantine",
    body: "Dito naghihintay ang mga mail na hindi makasali sa ticket nila. Walang naghihintay ngayon.",
    filteredTitle: "Walang mensaheng {{status}}",
    filteredBody: "Lalabas dito sa loob ng 30 araw ang mga mensaheng napagpasyahan mo.",
    action: "Ipakita ang mga naghihintay",
  },
  error: { title: "Hindi namin ma-load ang quarantine", body: "May nangyaring mali sa panig namin. Subukan ulit.", retry: "Subukan ulit" },
} as const;
